export const cifTn = ["301 201","<g fill-rule='nonzero' fill='none'><path fill='#E70013' d='M.5.5h300v200H.5z'/><circle fill='#FFF' cx='150.5' cy='100.5' r='50'/><circle fill='#E70013' cx='150.5' cy='100.5' r='37.5'/><circle fill='#FFF' cx='160.5' cy='100.5' r='30'/><path fill='#E70013' d='M138 100.5l40.703-13.225-25.156 34.624V79.102l25.156 34.624z'/></g>"]


//////////////////
// WEBPACK FOOTER
// ./node_modules/@coreui/icons/js/flag/cif-tn.js
// module id = null
// module chunks = 